module.exports = __webpack_public_path__ + "ef65056f9264096f1a336d5e2428877e.MP3";